export default __webpack_public_path__ + "776198f78e38a828dba944e5e0c1e6d7.png";